import HttpRequestService from "./HttpRequestService";

const OrgService = {};

const cntrlName = "Parent";


OrgService.SignUp = function (body) {
  return HttpRequestService.post(`${cntrlName}/BMSSignup`, body);
};

OrgService.Login = function (body) {
  return HttpRequestService.post(`${cntrlName}/BMSlogin`, body);
};


export default OrgService;
